module.exports = __webpack_public_path__ + "img/xls.2724255e.svg";